import { render, staticRenderFns } from "./globalTips.vue?vue&type=template&id=229335e1&scoped=true&"
import script from "./globalTips.vue?vue&type=script&lang=js&"
export * from "./globalTips.vue?vue&type=script&lang=js&"
import style0 from "./globalTips.vue?vue&type=style&index=0&id=229335e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229335e1",
  null
  
)

export default component.exports